module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe-wrap",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "wrapper",
    attrs: {
      "id": "swiper"
    }
  }, [_c('div', {
    staticClass: "carousel-wrapper"
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow,
      "height": 520
    },
    on: {
      "on-change": _vm.change
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.data), function(item) {
    return _c('CarouselItem', {
      key: item.key
    }, [_c('router-link', {
      attrs: {
        "to": item.to,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "img-box",
      style: ({
        backgroundImage: ("url(" + (item.atturl) + ")")
      })
    })])], 1)
  }), 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74982fd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/banner/carousel.vue
// module id = 1638
// module chunks = 1